import { render, staticRenderFns } from "./studentsList.vue?vue&type=template&id=082adc12&scoped=true"
import script from "./studentsList.vue?vue&type=script&lang=js"
export * from "./studentsList.vue?vue&type=script&lang=js"
import style0 from "./studentsList.vue?vue&type=style&index=0&id=082adc12&prod&scoped=true&lang=less"
import style1 from "./studentsList.vue?vue&type=style&index=1&id=082adc12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082adc12",
  null
  
)

export default component.exports